import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import basic from './modules/basic'
import template from './modules/template'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    basic,
    template
  }
})
